import React, { useState } from "react";
import LinkedDestinationTable from "./LinkedDestinationTable";
import { LinkedDestination } from "../../../../models/Entities";
import { useRequest } from "../../../shared/hooks/useRequest";
import DestinationDeletionModal from "./DestinationDeletionModal";
import DestinationFilters from "./DestinationFilters";
import useAppContext from "../../../context/useAppContext";
import { PROD_MERGE_ORGANIZATION_ID } from "../../../../constants";

const DestinationPageData = () => {
  const { user } = useAppContext();
  // state
  const [linkedDestinationToDelete, setLinkedDestinationToDelete] = useState<
    LinkedDestination | undefined
  >();
  const isLinkedDestinationDeletionModalOpen = linkedDestinationToDelete !== undefined;

  // hooks
  const {
    data: linked_destinations,
    loading,
    refetch,
  } = useRequest<Array<LinkedDestination>>({
    path: "/destinations/get-customer-linked-destinations",
  });

  // event handlers
  const onDeleteDestination = () => {
    setLinkedDestinationToDelete(undefined);
    // const indexToRemove = destinations!.findIndex(
    //   (destination) => destination.id == destinationToDelete!.id,
    // );
    // TODO: @ankitd make endpoint to remove destination and delete one https://app.asana.com/1/1174208460831550/project/1210177236619782/task/1210211904523877?focus=true
  };

  // We only show the button if the user has no linked destinations (only allowing them to link once)
  // or for the Merge org we allow unlimited destination linkage for testing
  const shouldShowButton =
    !linked_destinations ||
    linked_destinations.length == 0 ||
    user.organization.id === PROD_MERGE_ORGANIZATION_ID ||
    process.env.REACT_APP_MERGE_ENV == "DEVELOP" ||
    process.env.REACT_APP_MERGE_ENV == "MU-DEVELOP" ||
    process.env.REACT_APP_MERGE_ENV == "MU-STAGING";

  return (
    <>
      <div>
        {shouldShowButton && <DestinationFilters className="mb-6" refetchDestinations={refetch} />}
        <LinkedDestinationTable
          linked_destinations={linked_destinations}
          isLoading={loading}
          setLinkedDestinationToDelete={setLinkedDestinationToDelete}
        />
        {/* 
        @ankitd can readd this when we have multiple destinations allowed https://app.asana.com/1/1174208460831550/project/1210177236619782/task/1210238798928207?focus=true
        
        <PaginationFooter
          hasPrevious={hasPrevious}
          hasNext={hasNext}
          onPreviousClick={onPrevious}
          onNextClick={onNext}
        /> */}
      </div>
      <DestinationDeletionModal
        isModalOpen={isLinkedDestinationDeletionModalOpen}
        onDeleteDestination={onDeleteDestination}
        closeModal={() => setLinkedDestinationToDelete(undefined)}
        linkedDestination={linkedDestinationToDelete}
      />
    </>
  );
};

export default DestinationPageData;
